import { BottomSheet } from "components/BottomSheet";
import { DropdownFormProvider } from "components/DropdownFormProvider";
import { FormProvider } from "react-hook-form";
import { SheetPrimaryButton, SheetSecondaryButton } from "./SheetActions";
import { UpdateVehicleLogicRetVal } from "./useUpdateVehicleLogic";

type Props = {
  logic: UpdateVehicleLogicRetVal;
};

export const OperatorVehicleSheet = ({ logic }: Props) => (
  <BottomSheet
    isOpen={logic.isModalOpen}
    onClose={logic.onModalClose}
    title="Fordon"
  >
    <FormProvider {...logic.form}>
      <form className="space-y-6 pb-2" onSubmit={logic.onSubmit}>
        <DropdownFormProvider
          items={logic.vehicleDropdownItems}
          label="Fordon"
          name="vehicleUuid"
          hideClearButton
        />

        <div className="flex gap-x-3 border-t border-gray-75 pt-4">
          <SheetSecondaryButton onClick={logic.onModalClose} />
          <SheetPrimaryButton isLoading={logic.isPending}>
            Spara
          </SheetPrimaryButton>
        </div>
      </form>
    </FormProvider>
  </BottomSheet>
);
